export default (() => {
    function openDesktop() {
        var wrapper = $('.right-widget');
        var backdrop = $('#backdrop.toggle-right-widget');

        if(wrapper.hasClass('first')) {
            wrapper.removeClass('first');
        }

        if(wrapper.hasClass('open')) {
            wrapper.removeClass('open');
            backdrop.removeClass('active');
            return;
        }

        backdrop.addClass('active');
        wrapper.addClass('open');
    }

    function openMobile() {
        var backdrop = $('#backdrop.toggle-mobile-right-widget');
        var body = $('body');

        $('.right-widget .content-wrapper').slideToggle('slow', function(){

           if(body.hasClass('no-scroll')) {
               body.removeClass('no-scroll');
               $('.toggle-mobile-right-widget').removeClass('open');
               backdrop.removeClass('active');
               return;
           }

            body.addClass('no-scroll');
            $('.toggle-mobile-right-widget').addClass('open');
            backdrop.addClass('active');
        });
    }

    $('.toggle-right-widget').click(openDesktop);

    $('a[href*="#open-widget"]').click(function(e) {
        e.preventDefault();
        
        var type = getParameterByName('type', $(this).attr('href')),
            reference = getParameterByName('reference', $(this).attr('href'));

        if(type && reference) {
            $('.book-a-table-widget').attr('data-type', type);
            $('.book-a-table-widget').attr('data-reference', reference);
        }

        if($(window).width() > 768) {
            openDesktop();
            return;
        }

        openMobile();
    });

    $('.toggle-mobile-right-widget').click(openMobile);


    if($('body:not(.home) .widget-header').length > 0) {
        $('.toggle-right-widget.check-availability-btn').addClass('hide');

        $(window).on('scroll', function() {
            if($(window).width() < 768) {
                return;
            }

            var scrollPosition = $(window).scrollTop() + $('nav').outerHeight();
            var widgetPosition = $('.widget-header').outerHeight();

            if(scrollPosition > widgetPosition) {
                $('.toggle-right-widget.check-availability-btn').removeClass('hide');
                $('.toggle-right-widget.check-availability-btn').addClass('open');
                $('.toggle-right-widget.check-availability-btn').addClass('transition');
            } else {
                $('.toggle-right-widget.check-availability-btn').removeClass('open');
                $('.toggle-right-widget.check-availability-btn').addClass('hide');
            }
        });
    }

    function getParameterByName(name, url) {
        if (!url) url = window.location.href;
        name = name.replace(/[[\]]/g, '\\$&');
        var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }

    $('input[name="website-origin-url"]').each(function() {
        $(this).val(window.location.href);
    })
});



// WEBPACK FOOTER //
// ./scripts/components/right-side-widgets.js